import React from 'react';
import { observer } from 'mobx-react';

import {
  ORDERBIRD_PRIVACY_POLICY_URL,
  ORDERBIRD_TERMS_CONDITIONS_URL,
  RESMIO_PRIVACY_POLICY_URL,
  RESMIO_TERMS_CONDITIONS_B2C_URL,
} from 'app/constants';

import { ArrowIcon } from 'app/commonComponents/icons';
import form from 'modules/ticketPublicPage/stores/tickets/form';
import view from 'modules/ticketPublicPage/stores/tickets/view';
import { colors } from 'app/variables';

import {
  BackButton,
  ButtonBlock,
  ButtonGroup,
  ContinueButton,
  Privacy,
} from './ActionButtons.styles';
import config from '../../../config';

const ActionButtons = observer(() => {
  const { price } = view.activeObject;
  const isFree = !Number(price);
  const {
    step,
    DETAILS,
    PAYMENT,
    INITIAL,
    CONFIRMATION,
    onNextBtnClick,
    onBackBtnClick,
    disableSaveButton,
    hideBuyButton,
  } = form;

  const { facility } = view;
  const facilityNameOnly = step === INITIAL && !facility.website;

  const privacyText = i18n.sprintf(
    i18n.gettext(
      'By clicking the "Buy" button you agree to the <a target="_blank" href="%s" rel="nofollow">Terms & Conditions</a> and <a target="_blank" href="%s" rel="nofollow">Privacy Policy</a>'
    ),
    config.isOrderbirdFacility
      ? ORDERBIRD_TERMS_CONDITIONS_URL
      : RESMIO_TERMS_CONDITIONS_B2C_URL,
    config.isOrderbirdFacility
      ? ORDERBIRD_PRIVACY_POLICY_URL
      : RESMIO_PRIVACY_POLICY_URL
  );

  return (
    <ButtonBlock isSingleButton={step === CONFIRMATION}>
      {step === PAYMENT ? (
        <Privacy dangerouslySetInnerHTML={{ __html: privacyText }}></Privacy>
      ) : null}
      <ButtonGroup>
        <BackButton
          tabIndex="0"
          onClick={onBackBtnClick}
          hideOnDesktopView={step === INITIAL}
          style={{ pointerEvents: facilityNameOnly ? 'none' : 'initial' }}
        >
          {facilityNameOnly ? null : (
            <ArrowIcon
              rotate={90}
              style={{ color: 'inherit', height: '1.5rem', width: '1.5rem' }}
            />
          )}
          <span>
            {step === INITIAL
              ? facility.name
              : step === CONFIRMATION
                ? i18n.gettext('Buy another ticket')
                : i18n.gettext('Back')}
          </span>
        </BackButton>
        {step === DETAILS || step === INITIAL ? (
          <ContinueButton
            data-testid="footer_continue_button"
            onClick={onNextBtnClick}
            color={colors.pacificBlue}
            disabled={disableSaveButton}
            fullWidthOnDesktopView={step === INITIAL}
          >
            {isFree && step !== INITIAL
              ? i18n.gettext('Join')
              : step === INITIAL
                ? i18n.gettext('Next')
                : i18n.gettext('To payment')}
          </ContinueButton>
        ) : step === PAYMENT && !hideBuyButton ? (
          <ContinueButton
            onClick={onNextBtnClick}
            color={colors.pacificBlue}
            disabled={disableSaveButton}
          >
            {i18n.gettext('Buy')}
          </ContinueButton>
        ) : null}
      </ButtonGroup>
    </ButtonBlock>
  );
});

export default ActionButtons;
